var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ticketEventList && _vm.ticketEventList.length > 0
    ? _c(
        "div",
        [
          _c(
            "div",
            {
              staticClass:
                "el-divider el-divider--horizontal ticket-reply-switch-bar"
            },
            [
              _c("div", { staticClass: "el-divider__text is-center" }, [
                _c(
                  "span",
                  {
                    staticClass: "ticket-reply-switch-item",
                    class: {
                      "ticket-reply-switch-item-active":
                        "all" == _vm.ticketEventFilter
                    },
                    attrs: { title: "显示所有工单回复和操作记录" },
                    on: { click: _vm.showAll }
                  },
                  [_vm._v("全部")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "ticket-reply-switch-item",
                    class: {
                      "ticket-reply-switch-item-active":
                        "reply" == _vm.ticketEventFilter
                    },
                    attrs: { title: "仅显示工单回复,不显示其他操作记录" },
                    on: { click: _vm.showReply }
                  },
                  [_vm._v("仅回复")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "ticket-reply-switch-item",
                    class: {
                      "ticket-reply-switch-item-active":
                        "attachment" == _vm.ticketEventFilter
                    },
                    attrs: { title: "仅显示有附件的工单回复" },
                    on: { click: _vm.showAttachment }
                  },
                  [_vm._v("附件")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "ticket-reply-switch-item",
                    class: {
                      "ticket-reply-switch-item-active":
                        "form" == _vm.ticketEventFilter
                    },
                    attrs: { title: "仅显示有表单的记录" },
                    on: { click: _vm.showForm }
                  },
                  [_vm._v("表单")]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.ticketEventListFiltered, function(flow, index) {
            return _c(
              "div",
              {
                key: flow.id,
                class: [
                  "ticket_event_0",
                  { private_ticket_event: !flow.visible }
                ]
              },
              [
                _c(
                  "p",
                  { staticClass: "ticket-event-style" },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "color-orange",
                        staticStyle: { display: "inline-block", width: "35px" }
                      },
                      [
                        _vm._v(
                          "#" +
                            _vm._s(_vm.ticketEventListFiltered.length - index)
                        )
                      ]
                    ),
                    _vm._v("\n            由\n            "),
                    _c("TicketUser", { attrs: { userId: flow.dealUserId } }),
                    _vm._v("\n            于\n            "),
                    _c("span", { attrs: { title: flow.createdAt } }, [
                      _vm._v(_vm._s(_vm._f("ticketTime")(flow.createdAt)))
                    ]),
                    _vm._v(" "),
                    _c("TicketOrigin", {
                      model: {
                        value: flow.originId,
                        callback: function($$v) {
                          _vm.$set(flow, "originId", $$v)
                        },
                        expression: "flow.originId"
                      }
                    }),
                    _vm._v(" "),
                    _c("TicketEventVisibleSwitch", {
                      attrs: { ticketEvent: flow }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "color-orange padding-l-xs" }, [
                      _vm._v(_vm._s(flow.operateContent))
                    ]),
                    _vm._v(" "),
                    flow.operateContent != "添加回复" ? _c("span") : _vm._e(),
                    _vm._v(" "),
                    flow.assignUserId
                      ? [
                          _vm._v(
                            "\n                ，指派给 \n                "
                          ),
                          _c("TicketUser", {
                            attrs: { userId: flow.assignUserId }
                          })
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    !!flow.noticeUserList && flow.noticeUserList.length > 0
                      ? [
                          _vm._v(
                            "\n                ，抄送给 \n                "
                          ),
                          _vm._l(flow.noticeUserList, function(n, index) {
                            return _c("div", { key: n.id }, [
                              _c("span", { staticClass: "color-orange" }, [
                                _vm._v(
                                  _vm._s(n.noticeUserGroupName) +
                                    " " +
                                    _vm._s(n.noticeUserName)
                                )
                              ]),
                              _vm._v(" "),
                              index < flow.noticeUserList.length - 1
                                ? _c("span", [_vm._v(",")])
                                : _vm._e()
                            ])
                          })
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                flow.orderRemark
                  ? _c("p", {
                      staticClass:
                        "ticket-img-style ticket-event-style ticket-content",
                      domProps: {
                        innerHTML: _vm._s(flow.orderRemark.remarkContent)
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !!flow.taskId
                  ? _c("TicketTaskForm", {
                      attrs: { fullScreen: true, taskId: flow.taskId },
                      on: { change: _vm.onTicketTaskFormChange }
                    })
                  : _vm._e(),
                _vm._v(" "),
                flow.orderRemark && flow.orderRemark.attachmentList.length > 0
                  ? _c(
                      "div",
                      { staticClass: "ticket-img-style ticket-event-style" },
                      _vm._l(flow.orderRemark.attachmentList, function(l) {
                        return _c(
                          "div",
                          { key: l.id },
                          [
                            _vm.isImage(l)
                              ? _c("el-image", { attrs: { src: l.filePath } })
                              : _vm.isAudio(l)
                              ? _c("audio", {
                                  attrs: {
                                    controls: "",
                                    src: l.filePath,
                                    preload: "meta"
                                  }
                                })
                              : _vm.isVideo(l)
                              ? _c("video", {
                                  attrs: {
                                    controls: "",
                                    src: l.filePath,
                                    width: "640",
                                    height: "360"
                                  }
                                })
                              : _c(
                                  "a",
                                  {
                                    attrs: {
                                      href:
                                        l.filePath + "?attname=" + l.fileName,
                                      target: "_blank",
                                      title: "点击下载 回复附件[45]"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-download"
                                    }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(l.fileName))])
                                  ]
                                )
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ],
              1
            )
          }),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "300px" } }),
          _vm._v(" "),
          _c("TicketFormOperationBar", {
            ref: "TicketFormOperationBar",
            on: { submit: _vm.onTicketFormOperationBarSubmit }
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e0ab5dce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0ab5dce","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketEventList.vue
// module id = 800
// module chunks = 75